"use client";

import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { CheckIcon } from "lucide-react";

import { cn } from "./utils";

function Checkbox({
  className,
  checked,
  disabled,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  
  const baseStyle: React.CSSProperties = {
    width: 16,
    height: 16,
    borderRadius: 4,
    border: "1px solid #ccc",
    backgroundColor: checked ? "#1f57d6" : "#f3f4f6",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.5 : 1,
    transition: "all 0.2s ease",
  };

  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      checked={checked}
      disabled={disabled}
      style={baseStyle}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
        }}
      >
        <CheckIcon style={{ width: 14, height: 14 }} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  );
}


export { Checkbox };
